var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.346,
    height: 12.008,
    viewBox: "0 0 73.346 12.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762",
    transform: "translate(-125.82 -145.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(123.57 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star-2",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(138.769 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star-3",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(153.969 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star-4",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(169.168 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star-5",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(184.367 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.1060168345fb5b6170e4734375dc0adc.svg";
export { ForwardRef as ReactComponent };